const academyRoutes = [
  {
    path: '/academy',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'companies',
        name: 'academy.companies',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'academy.companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Academy'
            },
            {
              title: 'Companies',
              active: true
            }
          ],
          pageTitle: 'Academy Companies',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'users',
        name: 'academy.users',
        component: () => import('@/components/archistar/table/UserCompanyTable.vue'),
        props: {
          scope: 'academy.users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Academy'
            },
            {
              title: 'Users',
              active: true
            }
          ],
          pageTitle: 'Academy Users',
          hideDefaultHeader: true,
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

export default academyRoutes;
